import { UseFormReturn } from 'react-hook-form';
import { MapFormValues } from './useMapForm';
import { HoverLabelToggle } from './HoverLabelToggle';

interface RadarHoverLabelsProps {
  form: UseFormReturn<MapFormValues>;
}

const RADAR_HOVER_FIELDS = [
  { name: 'radar_id', label: 'ID', description: 'Show radar target ID on hover' },
  { name: 'radar_name', label: 'Name', description: 'Show radar target name on hover' },
  { name: 'radar_sog', label: 'Speed Over Ground', description: 'Show radar target SOG on hover' },
  { name: 'radar_cog', label: 'Course Over Ground', description: 'Show radar target COG on hover' },
  { name: 'radar_lastRadarReport', label: 'Last Radar Report', description: 'Show last radar report time on hover' },
  { name: 'radar_lastOrigin', label: 'Last Origin', description: 'Show radar target last origin on hover' },
  { name: 'radar_latitude', label: 'Latitude', description: 'Show radar target latitude on hover' },
  { name: 'radar_longitude', label: 'Longitude', description: 'Show radar target longitude on hover' },
] as const;

export const RadarHoverLabels = ({ form }: RadarHoverLabelsProps) => {
  return (
    <div className="grid grid-cols-2 gap-4">
      {RADAR_HOVER_FIELDS.map((field) => (
        <HoverLabelToggle
          key={field.name}
          form={form}
          name={field.name}
          label={field.label}
          description={field.description}
        />
      ))}
    </div>
  );
};
